if($('.id--12 .table').length){
    var $table = $('.table');
    $table.find('th').each(function(index) {
        if ($(this).text().trim() === 'Bestelstatus') {
            $(this).hide();
            $table.find('tr').each(function() {
                $(this).find('td, th').eq(index).hide();
            });
        }
    });
}
if($('.id--18').length){
    $('p').each(function() {
        console.log(translation('statustext'))
        if ($(this).text().includes(translation('statustext'))) {
            var statusText = escapeRegex(translation('statustext'));
            var regex = new RegExp('<br>\\s*' + statusText + ':.*<\\/strong>', 'i');
            $(this).html(function(i, html) {
                return html.replace(regex, '');
            });
        }
    });
}

function escapeRegex(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}